import { useEffect } from 'react';
import syncStoreService from '@/store/syncStore/SyncStoreService';
import useIsMemberAuthorized from '@/hooks/useIsMemberAuthorized';

const useTinybaseListeners = () => {
    const isMemberAuthorized = useIsMemberAuthorized();

    useEffect(() => {
        if (!isMemberAuthorized) {
            return;
        }

        const unsubscribe = syncStoreService.subscribeToTheDataUpdate();

        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, [isMemberAuthorized]);
};

export default useTinybaseListeners;
